module.exports = __webpack_public_path__ + "static/media/payment-method.eeb35b4b.svg";